/** Mantém o tenant da URL e a área de trabalho atual na navegação clínica. */
export const buildClinicalAssessmentPath = (pathname: string, patientId: string, anamnesisRecordId?: string): string => {
  const segments = pathname.split('/').filter(Boolean);
  const roleIndex = segments.findIndex((segment) => ['admin', 'fisioterapeuta', 'doctor', 'interno'].includes(segment));
  const prefix = roleIndex >= 0 ? segments.slice(0, roleIndex) : [];
  const physiotherapist = roleIndex >= 0 && segments[roleIndex] === 'fisioterapeuta';
  const path = [...prefix, physiotherapist ? 'fisioterapeuta' : 'admin', physiotherapist ? 'avaliacoes' : 'assessments-v2'];
  const params = new URLSearchParams({ patientId });
  if (anamnesisRecordId) {
    params.set('action', 'from-anamnesis');
    params.set('anamnesisId', anamnesisRecordId);
  }
  return `/${path.join('/')}?${params.toString()}`;
};
